import { RHColors, RHFont, RHSpacing } from "./RHDesignTokens"

export const StatisticsPageDesignTokens = {

    pageBackgroundColor: RHColors.pageBackground,
    wideContentMaxWidth: 1760,
    titleTextColor: RHColors.textPrimary,
    explanationTextColor: RHColors.statisticsExplanationText,
    explanationFontWeight: RHFont.weightRegular,
    explanationMaxWidth: 980,
    explanationMinHeight: 20,
    explanationBottomGap: RHSpacing.small + RHSpacing.tiny,
    frontCtaButtonVariant: "primary" as const,
    frontCtaButtonWidth: 220,
    frontCtaButtonGap: RHSpacing.small + RHSpacing.tiny,
    chartPanelBackgroundColor: RHColors.white,
    chartToggleSelectedVariant: "primary" as const,
    chartToggleUnselectedVariant: "light" as const,
    chartSecondaryColor: RHColors.statisticsChartSecondary.stringValue,
    chartAxisTextColor: RHColors.slateDark.stringValue,
    chartAxisLineColor: RHColors.slateLightest.stringValue,
    chartTitleTextColor: RHColors.textHeading.stringValue,
    chartSubtitleTextColor: RHColors.slateMedium.stringValue,
    chartSplitLineColor: RHColors.borderLight.stringValue,
    chartTooltipBackgroundColor: RHColors.whiteAlpha98.stringValue,
    chartTooltipBorderColor: RHColors.statisticsChartTooltipBorder.stringValue,
    chartTooltipTextColor: RHColors.textHeading.stringValue,
    chartTitleFontSize: 16,
    chartTitleFontWeight: Number(RHFont.weightSemibold),
    chartAxisLabelFontSize: 11,
    chartYAxisLabelMargin: 10,
    chartDataZoomBackgroundColor: RHColors.surfaceCool.stringValue,
    chartDataZoomFillerColor: RHColors.primaryBlueAlpha16.stringValue,
    chartDataZoomBorderColor: RHColors.statisticsChartDataZoomBorder.stringValue,
    chartDataZoomHandleColor: RHColors.white.stringValue,
    chartDataZoomHandleBorderColor: RHColors.statisticsChartDataZoomHandleBorder.stringValue,
    chartDataZoomHandleShadowColor: RHColors.primaryBlueAlpha18.stringValue,
    chartBarMaxWidth: 30,
    tableSubRowBackgroundColor: RHColors.statisticsTableSubRowBackground,
    tableSubRowTextColor: RHColors.slateDark,
    filterControlGap: RHSpacing.small + RHSpacing.tiny,
    comparisonFilterFieldWidth: 122,
    dropdownMinHeight: 64,
    emptyStateMessageSingle: "Vali hankija või pakkuja ning vähemalt üks periood ja menetlusliik.",
    emptyStateMessageComparison: "Vali aasta, võrdlusparameeter ja vähemalt üks menetlusliik."

} as const
